import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from '../../helper/className';

class Dropdown extends Component {

  static className = 'dropdown-component';

  static getClassName = getClassNameGenerator(Dropdown.className);

  static propTypes = {
    className: PropTypes.string,
    titleRenderer: PropTypes.func,
    children: PropTypes.any,
    maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  static defaultProps = {
    maxHeight: 'auto'
  };

  self;

  constructor() {
    super();
    this.state = {
      open: false
    };
  }

  componentWillMount() {
    window.document.addEventListener('click', this.handleDocumentClick);
  }

  componentWillUnmount() {
    window.document.removeEventListener('click', this.handleDocumentClick);
  }

  render() {
    const { className, titleRenderer, children, maxHeight } = this.props;

    return (
      <div ref={(element) => { this.self = element; }}
           className={classNames(className, Dropdown.className)}
           onClick={this.handleClick}
      >
        <div className={Dropdown.getClassName('title')} onClick={this.handleToggle}>
          {titleRenderer()}
        </div>
        <div className={classNames(
          {
            [Dropdown.getClassName('content', true, 'open')]: this.state.open
          }, Dropdown.getClassName('content'))
        } style={{ maxHeight }}>
          {children}
        </div>
      </div>
    )
  }

  handleDocumentClick = (e) => {
    if (this.self.contains(e.target)) {
      return;
    }

    this.setState({ open: false });
  }

  handleToggle = () => {
    this.setState({ open: !this.state.open })
  }

  handleClick = () => {
    // e.stopPropagation();
  }
}

export default Dropdown;
